// Compartilhado entre a aba Recorrência (Cadastro de Clientes) e a tela
// Vendas → Gerar Recorrência.

export const fmtMoeda = v => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
export const fmtData = v => (v ? String(v).slice(0, 10).split('-').reverse().join('/') : '');

export const DIAS_VENCIMENTO = Array.from({ length: 31 }, (_, i) => i + 1);
export const rotuloDia = d => `Todo dia ${String(d).padStart(2, '0')}`;

// "Layout do boleto" = conta bancária que emite (cada uma com sua integração).
export function rotuloConta(c) {
  if (c.integracao_boleto === 'cora') return `${c.nome} — Cora`;
  if (c.integracao_boleto === 'cnab400') return `${c.nome} — CNAB400${c.banco_codigo ? ` banco ${c.banco_codigo}` : ''}`;
  return `${c.nome} — sem integração de boleto`;
}

export function situacaoDoMes(r) {
  if (!r.venda_id) return { texto: 'Não gerada', cor: '#6b7280' };
  if (r.venda_status === 'cancelada') return { texto: `Venda #${r.venda_id} cancelada`, cor: '#c62828' };
  const partes = [`Venda #${r.venda_id}`];
  partes.push(r.boleto_id ? `boleto ${r.boleto_status}` : 'sem boleto');
  if (r.nfse_status === 'autorizada') partes.push(`NFS-e nº ${r.nfse_numero}`);
  else if (r.nfse_status) partes.push(`NFS-e ${r.nfse_status}`);
  if (r.email_enviado_em) partes.push('e-mail enviado');
  else if (r.email_erro) partes.push(`e-mail: ${r.email_erro}`);
  const problema = (r.nfse_status && r.nfse_status !== 'autorizada') || (!r.email_enviado_em && r.email_erro) || r.aviso;
  return { texto: partes.join(' · '), cor: problema ? '#e65100' : '#1b7a3d', dica: r.aviso || r.nfse_motivo || '' };
}
